import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_API_URL;

export const verifyEmail = async (email) => {
  try {
    const response = await axios.post(`${baseURL}/verification/email`, {
      email,
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const verifyRecaptcha = async (token) => {
  try {
    const response = await axios.post(`${baseURL}/verification/recaptcha`, {
      token,
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const verifyPhone = async (phoneNumber, countryCode) => {
  try {
    const response = await axios.post(`${baseURL}/verification/phone`, {
      phoneNumber,
      countryCode,
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getIpAddress = async () => {
  try {
    const response = await fetch(`${baseURL}/verification/get-ip`);
    const { ip } = await response.json();
    return ip;
  } catch (error) {
    console.error('Error fetching IP address:', error.message);
    return null;
  }
};